export const AWS_INTEGRATION_CONSTANTS = {
    SYNC_TYPES: {
        CHINA: 'CHINA',
        GOV_CLOUD: 'GOV_CLOUD',
        ALL: 'SYNC_ALL',
        SELECTED: 'SYNC_SELECTED',
    },
};
